<app-side-menu>
  <div class="templates-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-contract me-3"></i>
                Templates de Contratos
              </h1>
              <p class="page-subtitle">Pastas de modelos de documentos por área</p>
            </div>
            <div>
              <app-button
                text="Nova Pasta"
                color="var(--primary-color)"
                (buttonClick)="openCreateModal()">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="templates-card">
          <div *ngIf="isLoading">Carregando...</div>

          <!-- Estado vazio -->
          <div *ngIf="!isLoading && (!folders || folders.length === 0)" class="empty-state">
            <i class="fas fa-folder-open"></i>
            <h3>Nenhuma pasta encontrada</h3>
            <p>As pastas de templates serão exibidas aqui quando disponíveis.</p>
          </div>

          <!-- Tabela Genérica -->
          <div *ngIf="!isLoading && folders && folders.length > 0">
            <app-table
              [title]="'Lista de Pastas'"
              [data]="folders"
              [columns]="columns"
              [loading]="isLoading"
              [showSearch]="true"
              [searchPlaceholder]="'Buscar por nome, área ou observação...'"
              [clickable]="false"
              [actions]="actions"
              [useDropdownMenu]="true"
              [enableSorting]="true"
              (sortChange)="onSortChange($event)"
              (actionClick)="onActionClick($event)">
            </app-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal para Criar Nova Pasta -->
  <div *ngIf="showCreateModal" class="modal show" tabindex="-1" role="dialog" aria-labelledby="createModalLabel" aria-hidden="false">
    <!-- Backdrop da Modal -->
    <div class="modal-backdrop show" (click)="closeCreateModal()"></div>
    
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="createModalLabel">
            <i class="fas fa-folder-plus me-2"></i>
            {{ editingFolder ? 'Editar Pasta de Template' : 'Criar Nova Pasta de Template' }}
          </h5>
          <button type="button" class="btn-close" (click)="closeCreateModal()" aria-label="Close">×</button>
        </div>
        
        <form [formGroup]="createForm" (ngSubmit)="submitForm()">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="name" class="form-label">Nome da Pasta *</label>
                  <input type="text" 
                         class="form-control" 
                         id="name" 
                         formControlName="name" 
                         [class.is-invalid]="createForm.get('name')?.invalid && createForm.get('name')?.touched"
                         placeholder="Ex: Cobrança de Locação de Veículo">
                  <div class="invalid-feedback" *ngIf="createForm.get('name')?.invalid && createForm.get('name')?.touched">
                    Nome é obrigatório e deve ter pelo menos 3 caracteres.
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="area" class="form-label">Área *</label>
                  <input type="text" 
                         class="form-control" 
                         id="area" 
                         formControlName="area" 
                         [class.is-invalid]="createForm.get('area')?.invalid && createForm.get('area')?.touched"
                         placeholder="Ex: Cobrançã">
                  <div class="invalid-feedback" *ngIf="createForm.get('area')?.invalid && createForm.get('area')?.touched">
                    Área é obrigatória e deve ter pelo menos 2 caracteres.
                  </div>
                </div>
              </div>
            </div>
            
            <div class="mb-3">
              <label for="observation" class="form-label">Observação</label>
              <textarea class="form-control" 
                        id="observation" 
                        formControlName="observation" 
                        rows="3"
                        placeholder="Ex: Template padrão para cobrança de motos e veículos"></textarea>
            </div>
            
            <div class="mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
                <label class="form-check-label" for="isActive">
                  Pasta ativa
                </label>
              </div>
            </div>
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeCreateModal()" [disabled]="isCreating">
              <i class="fas fa-times me-2"></i>
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" (click)="submitForm()" [disabled]="createForm.invalid || isCreating">
              <span *ngIf="isCreating" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <i *ngIf="!isCreating" class="fas fa-save me-2"></i>
              {{ editingFolder ? (isCreating ? 'Salvando...' : 'Salvar') : (isCreating ? 'Criando...' : 'Criar Pasta') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-side-menu>


